<template>
    <div class="tile-content">
        <p class="stack-m">{{ description }}</p>
        <div class="stack-m">
            <div class="grid-item grid-item-half grid-item-break-half">
                <v-checkbox
                    :value="true"
                    v-model="hasIssueTimeShift"
                    label="Has Issued Time Shift"/>
            </div>
        </div>

        <template v-if="hasIssueTimeShift">
            <div class="grid-content stack-m">
                <div class="grid-item grid-item-full grid-item-break-half">
                    <div class="display-flex">
                        <div class="inline-s">Issue invoice</div>
                        <div style="max-width:70px;" class="inline-s">
                            <v-inline-input
                                placeholder="Duration"
                                :numeric="true"
                                :value="instruction.issueTimeShift.duration"
                                :validate="validate.issueTimeShift.duration"
                                @input="updateIssueTimeShiftDuration"/>
                        </div>
                        <div class="inline-s">
                            <v-popper-select
                                label="Unit"
                                :options="issueTimeShiftTimeUnitList"
                                :value="instruction.issueTimeShift.unit"
                                :validate="validate.issueTimeShift.unit"
                                @input="updateIssueTimeShiftUnit"/>
                        </div>
                        <div class="inline-s">
                            <v-popper-select
                                label="Chronology"
                                :options="chronologiesList"
                                :value="instruction.issueTimeShift.chronology"
                                :validate="validate.issueTimeShift.chronology"
                                @input="updateIssueTimeShiftChronology"/>
                        </div>
                        period change.
                    </div>

                </div>
            </div>
        </template>

        <div class="stack-m">
            <div class="grid-item grid-item-full grid-item-break-half">
                <v-checkbox
                    :value="true"
                    v-model="hasDueTimeShift"
                    label="Has Due Time Shift"/>
            </div>
        </div>

        <template v-if="hasDueTimeShift">
            <div class="grid-content stack-m">
                <div class="grid-item grid-item-full grid-item-break-half">
                    <div class="display-flex">
                        <div class="inline-s">Shift the due time to</div>
                        <div style="max-width:70px;" class="inline-s">
                            <v-inline-input
                                placeholder="Duration"
                                :numeric="true"
                                :value="instruction.dueTimeShift.duration"
                                :validate="validate.dueTimeShift.duration"
                                @input="updateDueTimeShiftDuration"/>
                        </div>
                        <div class="inline-s">
                            <v-popper-select
                                label="Unit"
                                :options="dueTimeShiftTimeUnitList"
                                :value="instruction.dueTimeShift.unit"
                                :validate="validate.dueTimeShift.unit"
                                @input="updateDueTimeShiftUnit"/>
                        </div>
                        after issue.
                    </div>

                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import _ from '@/common/helpers/index';
    import {
        vCheckbox,
        vDateInput,
        vInlineInput,
        vPopperSelect,
        vRadio,
        vSelect,
    } from '@/components/form/index';
    import InvoiceTimeShiftModel from '@/common/models/invoice-time-shift-model';

    export default {
        name: 'invoice-time-shift-form',
        components: {
            vInlineInput,
            vCheckbox,
            vRadio,
            vSelect,
            vPopperSelect,
            vDateInput,
        },
        props: {
            description: {
                type: String,
                required: false,
                default: null,
            },
            model: {
                required: true,
                validator: value => value === InvoiceTimeShiftModel,
            },
            instruction: {
                required: true,
                validator: value => value instanceof InvoiceTimeShiftModel,
            },
            validate: {
                type: Object,
                required: true,
            },
        },
        computed: {
            hasIssueTimeShift: {
                get() {
                    return !!(this.instruction.issueTimeShift);
                },
                set(value) {
                    if (value) {
                        this.instruction.enableIssueTimeShift();
                    } else {
                        this.instruction.disableIssueTimeShift();
                    }
                    this.update();
                },
            },
            hasDueTimeShift: {
                get() {
                    return !!(this.instruction.dueTimeShift);
                },
                set(value) {
                    if (value) {
                        this.instruction.enableDueTimeShift();
                    } else {
                        this.instruction.disableDueTimeShift();
                    }
                    this.update();
                },
            },
            chronologiesList() {
                return Object
                    .values(this.model.InvoiceTimeShiftChronologies)
                    .map(value => ({
                        label: _.unKebabCase(value),
                        value,
                    }));
            },
            issueTimeShiftTimeUnitList() {
                if (this.hasIssueTimeShift) {
                    return this.timeUnitList(this.instruction.issueTimeShift.duration);
                }
                return {};
            },
            dueTimeShiftTimeUnitList() {
                if (this.hasDueTimeShift) {
                    return this.timeUnitList(this.instruction.dueTimeShift.duration);
                }
                return {};
            },
        },
        methods: {
            timeUnitList(duration) {
                return this.model
                    .getUnitsList()
                    .map(value => ({
                        label: _.capitalize(_.pluralize(value, duration)),
                        value,
                    }));
            },
            update() {
                this.$emit('update', this.instruction.getPayload());
            },
            updateIssueTimeShiftChronology(chronology) {
                this.instruction.issueTimeShift.chronology = chronology;
                this.update();
            },
            updateIssueTimeShiftDuration(duration) {
                this.instruction.issueTimeShift.duration = +duration;
                this.update();
            },
            updateIssueTimeShiftUnit(unit) {
                this.instruction.issueTimeShift.unit = unit;
                this.update();
            },
            updateDueTimeShiftDuration(duration) {
                this.instruction.dueTimeShift.duration = +duration;
                this.update();
            },
            updateDueTimeShiftUnit(unit) {
                this.instruction.dueTimeShift.unit = unit;
                this.update();
            },
        },
    };
</script>
